import {Parameter} from './Parameter';

export class Generic {
  parameters: Parameter[];
  assignedParameters: Parameter[];
}
